module.exports = __webpack_public_path__ + "img/ParlamiDiMare-1.1c3e74b1.jpeg";